module.exports = __webpack_public_path__ + "img/przy-odbiorze.656041a1.svg";